// the whole file is presentation only so we disable jsx-ally
/* eslint jsx-a11y/onclick-has-role: 0 */
/* eslint jsx-a11y/img-has-alt: 0 */

//window.console.log = function() {};

import React from 'react';
//import ReactDOM from 'react-dom';
//import Reflux from 'reflux';

import steleSVG from '../../SteleSVG.js';
import * as config from '../../../../config.js';


/**
 * render charging station according to current parameters
 * @param{SteleCharging} charging		data object describing charging stations
 * @param{Function} storeChargingRect	function to call to store render objects ref
 * @param{Number} [steleRotation] 		global rotation of stele
 * @returns{?JSX} 						rendered charging or null if there's none
 */
export default function(charging, storeChargingRect, steleRotation) {
	let chargingName = config.PART_MODUL_CHARGING_NAME + charging.count;
	let extraRotation = 0; // values are related to the array of rotated images, which do _not_ start at 0° but by at accidental angle. So don't try to find any meaning in this value
	switch (charging.count) {
		/* eslint smells/no-complex-switch-case: 0 */
		case 2:
			chargingName += (charging.positioning === config.CHARGING_POSITION_2D180 ? '_180' : '_090' );
			extraRotation = (charging.positioning === config.CHARGING_POSITION_2D180) ? 90 :
				(charging.positioning < config.CHARGING_POSITION_2D180) ? 0 : 270;
			break;
		case 1:
			extraRotation = 360 + (charging.positioning-1) * -90;
			break;
		case 3:
			extraRotation = 270;
			break;
		default:
		// intentionally left blank
	}
	return (charging.count > 0 ? <img ref={storeChargingRect} className="slx-stele__charging" src={steleSVG.getPart(chargingName, (steleRotation +extraRotation)%360)} /> : null);
}
